// JavaScript Document
// Version: 1.5.0

/**
 * Crea l'anteprima della penna con o senza il template, in alta o in bassa risoluzione.
 *
 * @param  {string}   res      : risoluzione delle immagini
 * @param  {bool}     tpl      : true per utilizzare il template, altrimenti false
 * @param  {float}    resize   : fattore per riscalare il canvas
 * @param  {string}   format   : formato dell'immagine da restituire
 * @param  {bool}     imprint  : true per considerare anche la personalizzazione delle aree di stampa, altrimanti false
 * @param  {string}   viewCode : array con i codici delle viste
 * @param  {function} callback : funzione di callback
 *
 * @return {string}            : base64
 *
 * @since 1.0.0
 */
function createPreviewTemplate(res, tpl, resize, format, imprint, viewCode, callback) {
	var previewCanvas                 = new fabric.Canvas(jQuery('canvas', jQuery('#preview-canvas-container')).attr('id'));

	// Definisco il numero di cifre decimali per il fattore utilizzato per riscalare il canvas.
	fabric.Object.NUM_FRACTION_DIGITS = 5;

	// Dimensioni delle immagini dei componenti della penna.
	var lowImageWidth                 = parseFloat(minerva_configurator_vars.low_image_width);
	var lowImageHeight                = parseFloat(minerva_configurator_vars.low_image_height);
	var hiImageWidth                  = parseFloat(minerva_configurator_vars.hi_image_width);
	var hiImageHeight                 = parseFloat(minerva_configurator_vars.hi_image_height);

	// Percorsi relativi delle cartelle degli assets.
	var assetsFolder                  = minerva_configurator_vars.assets;
	var assetsHiresFolder             = minerva_configurator_vars.assets_hires;

	var views                         = jQuery('.pen-preview.imprint .view');
	var countViews                    = views.length;

	// Fattori di conversione.
	var cf;
	var lowToHi                       = hiImageHeight / lowImageHeight;
	var hiToLow                       = lowImageHeight / hiImageHeight;

	var viewLeftOffset;
	var previewWidth;
	var previewHeight;
	var templateUrl                   = minerva_configurator_vars.wp_content_url + '/';
	var templateImageWidth;
	var templateImageHeight;
	var canvasWidth;
	var canvasHeight;
	var space                         = parseFloat(minerva_configurator_vars.space);
	// A partire da FabricJS v.2.0.0 c'è il supporto ai display retina
	var devicePixelRatio              = 1; //window.devicePixelRatio;

	var xt;
	var yt;
	var fontSizeValues                = [];

	var logoImageMaxWidth;
	var logoImageMaxHeight;
	var cropMarginLeft;
	var cropMarginRight;
	var cropMarginTop;
	var cropMarginBottom;

	// "previewWidth" e "previewHeight" sono le dimensioni dell'anteprima senza il template.
	// Servono per poter centrare l'immagine all'interno del template.
	switch ( res ) {
		case 'low':
			cf                  = 1;
			previewWidth        = ( 'all' == viewCode ) ? (lowImageWidth * countViews + space * (countViews - 1)) : lowImageWidth;
			previewHeight       = lowImageHeight;
			viewLeftOffset      = lowImageWidth + space;
			templateUrl        += assetsFolder;
			templateName        = minerva_configurator_vars.low_template_filename;

			// Dimensioni del template in bassa risoluzione.
			templateImageWidth  = parseFloat(minerva_configurator_vars.low_template_image_width);
			templateImageHeight = parseFloat(minerva_configurator_vars.low_template_image_height);

			// Posizione di inserimento del testo (bottom-left).
			xt                  = parseFloat(minerva_configurator_vars.low_xt);
			yt                  = parseFloat(minerva_configurator_vars.low_yt);
			fontSizeValues      = [parseFloat(minerva_configurator_vars.low_body_font_size), parseFloat(minerva_configurator_vars.low_heading_font_size)];

			logoImageMaxWidth   = parseFloat(minerva_configurator_vars.low_logo_width);
			logoImageMaxHeight  = parseFloat(minerva_configurator_vars.low_logo_height);
			cropMarginLeft      = parseFloat(minerva_configurator_vars.low_crop_margin_left);
			cropMarginRight     = parseFloat(minerva_configurator_vars.low_crop_margin_right);
			cropMarginTop       = parseFloat(minerva_configurator_vars.low_crop_margin_top);
			cropMarginBottom    = parseFloat(minerva_configurator_vars.low_crop_margin_bottom);
			break;
		case 'hi':
			cf                  = lowToHi;
			previewWidth        = ( 'all' == viewCode ) ? (hiImageWidth * countViews + space * lowToHi * (countViews - 1)) : hiImageWidth;
			previewHeight       = hiImageHeight;
			viewLeftOffset      = hiImageWidth + space * lowToHi;
			templateUrl        += assetsHiresFolder;
			templateName        = minerva_configurator_vars.hi_template_filename;

			// Dimensioni del template in alta risoluzione.
			templateImageWidth  = parseFloat(minerva_configurator_vars.hi_template_image_width);
			templateImageHeight = parseFloat(minerva_configurator_vars.hi_template_image_height);

			// Posizione di inserimento del testo (bottom-left).
			xt                  = parseFloat(minerva_configurator_vars.hi_xt);
			yt                  = parseFloat(minerva_configurator_vars.hi_yt);
			fontSizeValues      = [parseFloat(minerva_configurator_vars.hi_body_font_size), parseFloat(minerva_configurator_vars.hi_heading_font_size)];

			logoImageMaxWidth   = parseFloat(minerva_configurator_vars.hi_logo_width);
			logoImageMaxHeight  = parseFloat(minerva_configurator_vars.hi_logo_height);
			cropMarginLeft      = parseFloat(minerva_configurator_vars.hi_crop_margin_left);
			cropMarginRight     = parseFloat(minerva_configurator_vars.hi_crop_margin_right);
			cropMarginTop       = parseFloat(minerva_configurator_vars.hi_crop_margin_top);
			cropMarginBottom    = parseFloat(minerva_configurator_vars.hi_crop_margin_bottom);
			break;
	}

	if ( is_defined(Cookies.get('dealer')) ) {
		templateName += '-dealer';
	}

	templateUrl +=  '/' + templateName + '.' + format;

	// "x0" e "y0" sono le coordinate (top-left) del punto di origine per l'inserimento delle immagini all'interno del template.
	var x0;
	var y0;

	if ( tpl ) {
		canvasWidth  = templateImageWidth;
		canvasHeight = templateImageHeight
		x0           = templateImageWidth / 2 - previewWidth / 2;
		// Il template in bassa risoluzione ha un'altezza che non rispecchia le proporzioni della versione in alta risoluzione, ma risulta più alto del dovuto per permettere una corretta disposizione dei testi.
		// 375 < templateImageHeight / 2
		//y0           = ( res == 'low' ) ? 375 - previewHeight / 2 : templateImageHeight / 2 - previewHeight / 2 - 100;
		y0           = ( res == 'low' ) ? 375 - previewHeight / 2 : templateImageHeight / 2 - previewHeight / 2 - ( previewHeight * 0.045 );
	} else {
		canvasWidth  = previewWidth;
		canvasHeight = previewHeight;
		x0           = 0;
		y0           = 0;
	}

	previewCanvas.setBackgroundColor('');
	// Definisco le dimensioni del canvas sulla base delle dimensioni del template in relazione alla risoluzione.
	previewCanvas.setDimensions({
		width: canvasWidth,
		height: canvasHeight
	});

	// Ad ogni vista associo il corrispondente valore del leftOffset.
	var leftOffsets = {};

	if ( 'all' == viewCode ) {
		views.each(function(mainIndex, element) {
			leftOffsets[jQuery(element).data('view-code')] = x0 + viewLeftOffset * mainIndex;
		});
	} else {
		leftOffsets[viewCode] = x0;
	}

	var imageDataUrl = null;
	var viewDefs     = [];
	var templateImage;

	function renderTemplate(templateUrl) {
		var renderTemplateDeferred = jQuery.Deferred();

		fabric.Image.fromURL(templateUrl, function(image) {
			image.set({
				left: 0,
				top: 0
			});
			templateImage = image;

			renderTemplateDeferred.resolve();
		});

		return renderTemplateDeferred.promise();
	}

	jQuery.when(renderTemplate(templateUrl)).done(function() {
		if ( tpl ) {
			previewCanvas.add(templateImage);
		}

		views.each(function(mainIndex, element) {
			var ctx             = jQuery(this);
			var currentViewCode = ctx.data('view-code');

			if ( 'all' == viewCode || currentViewCode == viewCode ) {
				viewDefs.push(renderViews(ctx, currentViewCode));

				function renderViews(ctx, currentViewCode) {
					var renderViewsDeferred = jQuery.Deferred();
					var layers              = [];
					var defs                = [];

					// Inserisco le immagini dei componenti della penna.
					jQuery('.refill-picture:not(.hidden), .pen-picture', ctx).each(function(index, element) {
						var src = ( res == 'low' ) ? jQuery(this).attr('src') : jQuery(this).attr('src').replace(assetsFolder, assetsHiresFolder);

						defs.push(addLayer(src, index));

						function addLayer(src, index) {
							var addLayerDeferred = jQuery.Deferred();

							fabric.Image.fromURL(src, function(image) {
								image.set({
									left: leftOffsets[currentViewCode],
									top: y0 + 0
								});
								layers[index] = image;

								addLayerDeferred.resolve();
							});

							return addLayerDeferred.promise();
						}
					}); // FINE .each sulle immagini dei componenti di una data vista.

					jQuery.when.apply($, defs).done(function () {
						jQuery(layers).each(function(index, element) {
							previewCanvas.add(element);
						});

						if ( imprint ) {
							var imgInstances     = [];
							var imgInstancesDefs = [];

							jQuery('.print-area', ctx).each(function(index, element) {
								var subCtx          = jQuery(this);
								var imageShift      = subCtx.data('image-shift') ? parseFloat(subCtx.data('image-shift')) : 0;
								var printAreaWidth  = parseFloat(subCtx.css('width').replace('px', '')) * lowToHi;
								var printAreaHeight = parseFloat(subCtx.css('height').replace('px', '')) * lowToHi;
								var printAreaLeft   = parseFloat(subCtx.css('left').replace('px', '')) * cf + leftOffsets[currentViewCode];
								var printAreaTop    = parseFloat(subCtx.css('top').replace('px', '')) * cf + y0;
								var imgInstance;
								var tempImage;

								// Inserisco le immagini presenti nelle aree di stampa.
								if ( jQuery('.print-area-content img', subCtx).length > 0 ) {
									var img           = jQuery('.print-area-content img', subCtx);
									var imgElementUrl = img.attr('src');
									var imgElement    = img[0];

									imgInstancesDefs.push(renderPAI(imgElementUrl));
								}

								function renderPAI(imgElementUrl) {
									var renderPAIDeferred = jQuery.Deferred();

									fabric.Image.fromURL(imgElementUrl, function(image) {
										image.set({
											clipPath: new fabric.Rect({
												left: -printAreaWidth / 2 - imageShift * lowToHi,
												top: -printAreaHeight / 2,
												width: printAreaWidth,
												height: printAreaHeight,
												fill: '#000000'
											}),
											left: printAreaLeft - Math.abs((imgElement.naturalWidth / lowToHi) * cf / 2 + (-(printAreaWidth / lowToHi) * cf / 2 - imageShift * cf)),
											top: printAreaTop,
											scaleX: cf / lowToHi,
											scaleY: cf / lowToHi
										});
										imgInstances.push(image);
										renderPAIDeferred.resolve();
									});

									return renderPAIDeferred.promise();
								}

								// Inserisco il testo presente nelle aree di stampa.
								if ( jQuery('.print-area-content span', subCtx).length > 0 ) {
									printAreaWidth    = printAreaWidth * (cf / lowToHi);
									printAreaHeight   = printAreaHeight * (cf / lowToHi);

									var textElement   = jQuery('.print-area-content span', subCtx)[0];

									if ( jQuery(textElement).hasClass('input') ) {
										var customText = jQuery(textElement).text();
									} else {
										var customText = jQuery(textElement).html().replace(/<br>/g, "\n");
									}

									// Sembra che la proprietà CSS "transform" (e relative varianti: -webkit, -ms, -o, -moz) non venga letta sui dispositivi mobili.
									// Il valore restituito risulta sempre pari a 0.
									var textRotation  = jQuery(textElement).parent().data('text-rotation');
									var textLeft      = printAreaLeft + printAreaWidth / 2;
									var textTop       = printAreaTop + printAreaHeight / 2;
									var textInstance  = new fabric.Text(customText, {
										fontFamily: jQuery(textElement).css('font-family'),
										fontSize: parseFloat(jQuery(textElement).css('font-size').replace('px', '')) * cf,
										fontWeight: jQuery(textElement).css('font-weight'),
										fontStyle: jQuery(textElement).css('font-style'),
										fill: rgb2hex(jQuery(textElement).css('color')),
										angle: textRotation,
										originX: 'center',
										originY: 'center',
										textAlign: jQuery(textElement).css('text-align')
									});
									var textWidth     = textInstance.width;  // Math.min(textInstance.width, printAreaHeight);
									var textHeight    = textInstance.height; // Math.min(textInstance.height, printAreaWidth);
									var textAlign     = jQuery(textElement).css('text-align');

									// "fbtt" significa "From Bottom To Top".
									// "fttb" significa "From Top To Bottom".
									// Il testo ha come origine l'angolo in alto a sinistra, quindi cambia posizione durante la rotazione:
									//    - "fbtt" ha come riferimento l'angolo in basso a sinistra
									//    - "fttb" ha come riferimento l'angolo in alto a destra
									//
									// Questo riferimento viene inizialmente posizionato nell'angolo in basso a sinistra dell'area di stampa, successivamente avviene la centratura.
									// L'altezza e la larghezza del testo fanno sempre riferimento alla sua disposizione orizzontale, anche se il testo risulta ruotato.
									var textDirection = ( textRotation == 270 ) ? 'fbtt' : 'fttb';

									// Parametro per la centratura verticale del testo in base all'orientazione del testo.
									var textTopShift;

									// Il metodo "clipTo" ha il seguente sistema di riferimento (considerando il testo orizzontale):
									//    - origine nel centro del testo
									//    - ascisse positive verso destra
									//    - ordinate positive verso il basso
									//
									// Il sistema di riferimento ruota rigidamente con il testo.
									var clipTo_Y;
									var clipTo_X;

									switch ( textAlign + '-' + textDirection ) {
										case 'left-fbtt':
											textTopShift = printAreaHeight / 2 - textWidth / 2;
											clipTo_X     = - textWidth / 2;
											break;
										case 'center-fbtt':
											textTopShift = 0;
											clipTo_X     = - printAreaHeight / 2;
											break;
										case 'right-fbtt':
											textTopShift = - printAreaHeight / 2 + textWidth / 2;
											clipTo_X     = - (printAreaHeight - textWidth / 2);
											break;
										case 'left-fttb':
											textTopShift = - printAreaHeight / 2 + textWidth / 2;
											clipTo_X     = - textWidth / 2;
											break;
										case 'center-fttb':
											textTopShift = 0;
											clipTo_X     = - printAreaHeight / 2;
											break;
										case 'right-fttb':
											textTopShift = printAreaHeight / 2 - textWidth / 2;
											clipTo_X     = - (printAreaHeight - textWidth / 2);
											break;
									}

									textInstance.set({
										left: textLeft + imageShift * cf,
										top: textTop + textTopShift,
									});

									var addTextToCanvas = true;
									var clipTo_W;
									var clipTo_H        = Math.floor(printAreaHeight * 100) / 100;

									switch ( textDirection ) {
										case 'fbtt':
											if ( imageShift == 0 ) {
												clipTo_Y = - Math.floor((printAreaWidth / 2) * 100) / 100;
											} else if ( imageShift < 0 ) {
												// Se il centro del testo è all'interno dell'area di stampa "clipTo_Y" risulta negativo, altrimenti positivo.
												clipTo_Y =  printAreaLeft - (textLeft + imageShift * cf);
												clipTo_Y = ( clipTo_Y < 0 ) ? - Math.floor(Math.abs(clipTo_Y) * 100) / 100 : clipTo_Y;
												if ( (textLeft + imageShift * cf + textInstance.height / 2) < printAreaLeft )
													addTextToCanvas = false;
											} else if ( imageShift > 0 ) {
												clipTo_Y = - textHeight / 2;
												if ( (textLeft + imageShift * cf - textInstance.height / 2) > (printAreaLeft + printAreaWidth) )
													addTextToCanvas = false;
											}

											clipTo_W = Math.floor(printAreaWidth * 100) / 100;
											break;
										case 'fttb':
											if ( imageShift == 0 ) {
												clipTo_Y = - Math.floor((printAreaWidth / 2) * 100) / 100;
												clipTo_W = Math.floor(printAreaWidth * 100) / 100;
											} else if ( imageShift < 0 ) {
												// Se il centro del testo è all'interno dell'area di stampa "clipTo_Y" risulta positivo, altrimenti negativo.
												clipTo_Y =  - (printAreaLeft - (textLeft + imageShift * cf));
												clipTo_Y = ( clipTo_Y > 0 ) ? Math.floor(Math.abs(clipTo_Y) * 100) / 100 : clipTo_Y;
												clipTo_W = - Math.floor(printAreaWidth * 100) / 100;

												if ( (textLeft + imageShift * cf + textInstance.height / 2) < printAreaLeft ) {
													addTextToCanvas = false;
												}
											} else if ( imageShift > 0 ) {
												clipTo_Y = textHeight / 2;
												clipTo_W = Math.floor(printAreaWidth * 100) / 100;

												if ( (textLeft + imageShift * cf - textInstance.height / 2) > (printAreaLeft + printAreaWidth) ) {
													addTextToCanvas = false;
												}
											}
											break;
									}

									textInstance.clipPath = new fabric.Rect({
										left: clipTo_X,
										top: clipTo_Y,
										width: clipTo_H,
										height: clipTo_W,
										fill: '#000000'
									});

									if ( addTextToCanvas ) {
										previewCanvas.add(textInstance);
									}
								}
							}); // FINE .each sulle aree di stampa di una data vista.

							jQuery.when.apply($, imgInstancesDefs).done(function () {
								jQuery(imgInstances).each(function(index, element) {
									previewCanvas.add(element);
								});

								renderViewsDeferred.resolve();
							});
						} else {
							renderViewsDeferred.resolve();
						}
					}); // FINE jQuery.when.apply

					return renderViewsDeferred.promise();
				}
			}
		}); // FINE .each sulle viste.

		jQuery.when.apply($, viewDefs).done(function () {
			// Recupero le informazioni da aggiungere al template.
			if ( tpl ) {
				var avenirHeavy = new FontFaceObserver('avenir55heavy');

				avenirHeavy.load()
					.then(function() {
						// "summary" è un array del tipo
						//    [
						//       {int}    lunghezza della stringa relativa alla famiglia a cui appartiene la penna (es. 2 per "DS")
						//       {int}    lunghezza della stringa rimanente per completare il codice prodotto (es. 8 per "9 PMM-PP" se il codice prodotto è "DS9 PMM-PP")
						//       {string} tutte le informazioni descrittive della configurazione
						//    ]
						var summary       = getConfigurationSummary();
						var style         = {};
						var index         = 0;

						for ( i = 0; i < summary[0]; i++ ) {
							style[index] = {
								fontSize: fontSizeValues[1],
								fontWeight: 'normal',
								fontFamily: 'Avenir LT',
							};
							index++;
						}

						for ( i = 0; i < summary[1]; i++ ) {
							style[index] = {
								fontSize: fontSizeValues[1],
								fontWeight: 'bold',
								fontFamily: 'avenir55heavy',
							};
							index++;
						}

						var itextInstance = new fabric.IText(summary[2].trim(), {
							fontFamily: 'Avenir LT',
							fontSize: fontSizeValues[0],
							fill: '#000',
							lineHeight: 1.1,
							styles: {
								0: style
							}
						});

						itextInstance.set({
							left: xt,
							top: yt - itextInstance.height,
						});
						previewCanvas.add(itextInstance);
						previewCanvas.renderAll();

						if ( is_defined(Cookies.get('dealer')) ) {
							var logoImage = jQuery('#configurator-header .logo img');
							var logoUrl   = logoImage.attr('src');

							fabric.Image.fromURL(logoUrl, function(image) {
								var imageWidth  = image.width;
								var imageHeight = image.height;
								var logoScaleFactor;

								if ( imageWidth > imageHeight ) {
									logoScaleFactor = logoImageMaxWidth / imageWidth;
								} else {
									logoScaleFactor = logoImageMaxHeight / imageHeight;
								}

								logoScaleFactor = Math.min(logoImageMaxWidth / imageWidth, logoImageMaxHeight / imageHeight);

								image.scale(parseFloat(logoScaleFactor));
								image.set({
									left: templateImageWidth - cropMarginRight - imageWidth * logoScaleFactor,
									top: cropMarginTop
								});
								previewCanvas.add(image);
								previewCanvas.renderAll();

								renderComplete(imageDataUrl, previewCanvas, format, devicePixelRatio, resize, callback);
							}, { crossOrigin: 'Anonymous' });
						} else {
							renderComplete(imageDataUrl, previewCanvas, format, devicePixelRatio, resize, callback);
						}
					}).catch(function(e) {
						console.log(e);
					});
			} else {
				renderComplete(imageDataUrl, previewCanvas, format, devicePixelRatio, resize, callback);
			}
		}); // FINE .when sulle viste.

	});

}



/**
 * Effettua il resize del canvas se necessario.
 *
 * @param  {float}    resize           : fattore per riscalare il canvas
 * @param  {string}   imageDataUrl     :
 * @param  {string}   format           : formato dell'immagine da restituire
 * @param  {float}    devicePixelRatio :
 * @param  {function} callback         :
 *
 * @since 1.4.0
 */
function resizeCanvas(resize, imageDataUrl, format, devicePixelRatio, callback) {
	if ( resize != 1 ) {
		var tempImg    = new Image();

		tempImg.src    = imageDataUrl;
		tempImg.onload = function() {
			var tempCanvas  = new fabric.Canvas(jQuery('<canvas></canvas>')[0]);

			tempCanvas.setDimensions({
				width: tempImg.width * resize,
				height: tempImg.height * resize,
			});

			var imgInstance = new fabric.Image(tempImg, {
				left: 0,
				top: 0
			});

			imgInstance.scale(resize);
			tempCanvas.add(imgInstance);
			tempCanvas.renderAll();
			imageDataUrl = tempCanvas.toDataURL({ format: format, quality: 1, multiplier: 1 / devicePixelRatio });

			if ( typeof callback === 'function' && callback != null ) {
				callback(imageDataUrl);
			}
		};
	} else {
		if ( typeof callback === 'function' && callback != null ) {
			callback(imageDataUrl);
		}
	}
}



/**
 * Conclude il processo e genera l'immagine finale.
 *
 * @param {string}   imageDataUrl     :
 * @param {object}   previewCanvas    :
 * @param {string}   format           : formato dell'immagine da restituire
 * @param {float}    devicePixelRatio :
 * @param {float}    resize           : fattore per riscalare il canvas
 * @param {function} callback         :
 *
 * @since 1.5.0
 */
function renderComplete(imageDataUrl, previewCanvas, format, devicePixelRatio, resize, callback) {
	imageDataUrl = previewCanvas.toDataURL({ format: format, quality: 1, multiplier: 1 / devicePixelRatio });

	resizeCanvas(resize, imageDataUrl, format, devicePixelRatio, callback);
}
